import { Action, combineReducers } from 'redux';

import { ISelectFilterDefinitionOption } from '~src/spacesPlatform/services/FilterPanelService';

import { maxSiteRoleCountsForServerUsersSpaceReducer } from './MaxSiteRoleCountsForServerUsersSpaceReducer';
import { maxSiteRoleForServerUsersSpaceReducer } from './MaxSiteRoleForServerUsersSpaceReducer';

export interface ServerUsersSpaceState {
    maxSiteRoleCounts: ISelectFilterDefinitionOption<string>[];
    maxSiteRole: string;
}

export const serverUsersSpaceReducer: (
    previousState: ServerUsersSpaceState,
    action: Action
  ) => ServerUsersSpaceState = combineReducers<ServerUsersSpaceState>(
    {
      maxSiteRoleCounts: maxSiteRoleCountsForServerUsersSpaceReducer,
      maxSiteRole: maxSiteRoleForServerUsersSpaceReducer
    }
  );
